import request from '@/utils/request'

const prizeURL = {
  List: '/platform-prize/list',
  Created: '/platform-prize/create',
  Update: '/platform-prize/update',
  Delete: '/platform-prize/delete'
}

// 获奖列表 & 详情(参数传id = *)
export function fetchPrizeList (params) {
  return request({
    url: prizeURL.List,
    method: 'get',
    params
  })
}

// 新增
export function createdPrize (data) {
  return request({
    url: prizeURL.Created,
    method: 'post',
    data
  })
}

// 修改
export function updatePrize (data) {
  return request({
    url: prizeURL.Update,
    method: 'post',
    data
  })
}

// 删除
export function deletePrize (data) {
  return request({
    url: prizeURL.Delete,
    method: 'post',
    data
  })
}

export default {
  fetchPrizeList,
  createdPrize,
  updatePrize,
  deletePrize
}
